import SearchComponent from './SearchComponent';
export * from './SearchComponent';
export default SearchComponent;
